import { Heading } from '@chakra-ui/react';
import { PilaH, PilaV, Texto } from '../../atomos';
import MenuOpciones from '@/components/moleculas/MenuOpciones';
import { useTitulo } from '@/hooks/ContextoTituloCabecera';

const Cabecera = () => {
  const { titulo, subtitulo } = useTitulo();
  return (
    <PilaH
      alignContent={'center'}
      justifyContent={'center'}
      as='header'
      w={'full'}
    >
      <PilaH as='nav' justify={'space-between'} py={'6'} w={'full'}>
        <PilaV alignItems={"start"} spacing={0}>
          <Heading fontWeight={'medium'} size={"lg"} lineHeight={"none"}>{titulo}</Heading>
          <Texto color={"foreground-secondary"}>{subtitulo}</Texto>
        </PilaV>
        <MenuOpciones />
      </PilaH>
    </PilaH>
  );
};

export default Cabecera;
